import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { ADS_REFRESH_TOKEN_KEY, AuthService } from './auth.service';
import { Observable, tap } from 'rxjs';
import { PerispekService } from './perispek.service';

@Injectable()
export class PerispekGuard  {
    constructor(
        private authService: AuthService,
        private perispekService: PerispekService,
        private router: Router
    ) { }

    public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | Observable<boolean> {
        let redirectURI = route.queryParamMap.get('redirect') ?? undefined;
        // #54135 If token is passed then do auth
        if(route.queryParams.token) {
            return this.perispekService.canActivateWithToken(route).pipe(tap((canActivate) => {
                if(canActivate && redirectURI) {
                    redirectURI = decodeURI(redirectURI);
                    this.router.navigateByUrl(redirectURI);
                    return false;
                }

                this.router.navigate(['dashboard']);
                return false;
            }));
        }

        this.router.navigate(['welcome']);
        return false;
    }

}
